// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"SignUp_SignUp__68Btr"};